import { STORAGE_KEYS } from '~/storage-keys';

/**
 * A última visita ao feed de documentos, por empresa, guardada no aparelho. É o que separa o
 * "Novo" do resto: fica fora do cache de consultas porque é do usuário neste navegador, não do
 * backend, e o logout a apaga junto com a sessão. Sem storage (modo privado restrito), não há
 * marca e nada aparece como novo.
 */
export function readDocumentsSeenAt(clientId: number): number | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.documentsSeen(clientId));
    if (stored === null) return null;
    const seenAt = Date.parse(stored);
    return Number.isNaN(seenAt) ? null : seenAt;
  } catch {
    return null;
  }
}

export function markDocumentsSeen(clientId: number, at: Date = new Date()): void {
  try {
    localStorage.setItem(STORAGE_KEYS.documentsSeen(clientId), at.toISOString());
  } catch {
    /* storage indisponível: a próxima visita só não marca nada como novo */
  }
}

/** Publicado depois da última visita. Sem visita registrada, nada é novo: o feed já vem do mais recente. */
export function isNewSince(createdAt: string, seenAt: number | null): boolean {
  return seenAt !== null && Date.parse(createdAt) > seenAt;
}

/** Apaga a última visita de todas as empresas; o logout chama, e a próxima conta começa sem marca. */
export function forgetDocumentVisits(): void {
  try {
    const keys = Array.from({ length: localStorage.length }, (_, index) => localStorage.key(index));
    for (const key of keys) {
      if (key?.startsWith(STORAGE_KEYS.documentsSeenPrefix)) {
        localStorage.removeItem(key);
      }
    }
  } catch {
    /* storage indisponível: nada gravado para apagar */
  }
}
